/**
 * Created by ccczzz on 2020/7/17.
 */
import  TopMenu from '../../../components/TopMenuLogin'
import  Bottom from '../../../components/Bottom'
import fa from "element-ui/src/locale/lang/fa";
import {utils} from "xlsx";
export default{
    data(){
        return {
            agreementVisible:false,
            agreementAgree:false,
            uuid:'',
            waitTime:60,
            rightType:'1',
            //用户绑定的手机号码
            phoneNumber:'',
            phoneRealNumber:'',
            //更换设备验证码
            changeEquipCode:'',
            loginForm:{
                accounts:'',
                password:'',
                checkCode:'',
            },
            loginRules:{
                accounts:[
                    {required: true,message: '请输入手机号/证件号'},
                    {pattern:/^[0-9X]+$/,message:'手机号/证件号输入有误'}
                    // {pattern:/^[Xx0-9]+$/,message:'只允许录入字母、数字、文字',trigger: 'blur'}
                    ],
                password:[
                    {required: true,message: '请输入密码',trigger: 'blur'},
                    ],
                checkCode:[
                    {required: true,message: '请输入校验码'},
                ]
            },
            //验证码
            checkCodeBase:'',
            //后台获取的验证码id
            checkCodeId:'',
            codeBtnText:'获取验证码',
            problemInfo:[],
            token:'',
            loading:false,
            //安卓商店图片地址
            imgANUrl:'',
            //iOS商店图片地址
            imgIOSUrl:'',
            //服务根目录
            baseImgUrl:'',
            //用户服务协议版本号
            userAgreementVesion:'',
            //隐私政策版本号
            privacyAgreementVesion:'',
            tempLoginData:'',

        }
    },
    mounted(){
        sessionStorage.setItem('selectIndex','0');
        sessionStorage.setItem('seeDetail','1');
        var logined=sessionStorage.getItem('logined');
        if(logined=='1'){
            this.rightType='4';
        }else{
            // sessionStorage.setItem('token','');
            this.rightType='1';
        }
        this.baseImgUrl=this.$util.getImageUrl();
        this.getCheckCodeId();
        this.getCommonProblems();
        var _this=this;
        //登录用户行为记录
        this.$util.recordUserBehavior('','1','登录',function(uuid){
            _this.uuid=uuid;
        });
    },
    watch:{

    },
    beforeDestroy(){
        this.$util.recordUserBehavior(this.uuid,'2','登录',function(uuid){

        });
    },
    components: {
        TopMenu,
        Bottom,
    },
    methods: {
        getCommonProblems:function () {
            var _this=this;
            var data={
                //1 web端 2移动端
                // reqCode:'1',
            };
            // console.log('111');
            this.$http({
                url: '/commonProblem/commonProblemInfoWeb',
                method: 'post',
                data:data,
            }).then(function (res) {
               if(res.data.code=='200'){
                    var problemInfo=res.data.data;
                    _this.problemInfo=problemInfo;
                    // console.log(_this.problemInfo);
                    // console.log(_this.problermInfo2);
                }else{

                }
            }).catch(function (err) {
            })
        },
        //登录获取检验码
        getCheckCodeId:function () {
            var _this=this;
            var data={};
            this.checkCodeId='';
            this.$http({
                // url: '/user/check/getCode',
                url:'/check/getCode',
                method: 'post',
                data:data,
            }).then(function (res) {
                if(res.data.code=='200'){
                    var data=res.data.data;
                    _this.checkCodeId=data.checkCodeId;
                    _this.checkCodeBase=data.checkCodeBase;
                }else{
                    _this.checkCodeId='';
                    _this.checkCodeBase='';
                    // _this.message(({
                    //     showColse:true,
                    //     message:res.data.msg,
                    //     type: 'error'
                    // }));
                    _this.$message.error(res.data.msg);
                }
            }).catch(function (err) {
                _this.checkCodeId='';
                _this.checkCodeBase='';
            })
        },
        //更换验证码
        refreshVerificationCode:function () {
            this.getCheckCodeId();
        },
        //点击注册
        registerClick:function () {
            this.rightType='2';
            //获取安卓和iOS下载二维码图片
            this.getAPPStoreImg();
        },
        //点击登录按钮 账号、手机号登录操作
        handleLogin:function () {
            var _this=this;
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    var password='xfzfwpt'+this.loginForm.password+'xfzfwpt';
                    var md5password=_this.$md5(password);
                    md5password='zkr'+md5password+'zkr';
                    var agnMd5Paddword=_this.$md5(md5password);
                    var data={
                        phoneOrIdentityNo:this.loginForm.accounts,
                        passwd:agnMd5Paddword,
                        checkCodeId:this.checkCodeId,
                        checkCode:this.loginForm.checkCode,
                        machineType:"2"
                    };
                    this.loading=true;
                    this.$http({
                        url: '/login/loginuser',
                        //url: '/user/login/loginuser',
                        method: 'post',
                        data:data,
                    }).then(function (res) {
                        _this.loading=false;
                        if(res.data.code=='200'){
                            //是否实名认证
                            if(res.data.data.flag=='0'){
                                _this.$alert('需先到App端通过登录功能完善信息才能在PC端、公众号端登录', '提示', {
                                        confirmButtonText: '确定',
                                        type:'warning',
                                        callback: action => {
                                    }
                                });
                                return;
                            }
                            _this.tempLoginData=res.data.data;
                            _this.token=_this.tempLoginData.token;
                            _this.checkNewAgreement(res.data.data);

                        }else if(res.data.code=='5'){
                            _this.loginForm.checkCode='';
                            _this.refreshVerificationCode();
                            _this.$alert(res.data.msg, '提示', {
                                    confirmButtonText: '确定',
                                    type:'warning',
                                    callback: action => {
                                }
                            });
                        }else{
                            _this.loginForm.checkCode='';
                            _this.refreshVerificationCode();
                            _this.$message.error(res.data.msg);
                        }
                    }).catch(function (err) {
                        _this.loading=false;
                        _this.refreshVerificationCode();
                    })
                }else{

                }
            })
        },
        //切换手机号/账号登录页面
        changeLoginType:function () {
            this.loginForm.accounts='';
            this.loginForm.password='';
            this.loginForm.checkCode='';
            this.checkCodeId='';
            this.checkCodeBase='';
            this.getCheckCodeId();
            sessionStorage.clear();
            sessionStorage.setItem('logined','0');
            sessionStorage.setItem('token','');
            this.rightType='1';
        },
        //更换登录设备
        changeEquipLogin:function () {
            // this.rightType='4';
            var _this=this;
            _this.loading=true;
            var data={
                //1 代表APP 2代表PC
                machineType:'2',
                mobile:this.phoneRealNumber,
                phoneCode:this.changeEquipCode,
            }
            var userId=sessionStorage.getItem('userId');
            var token=this.token;
            this.$http({
                // url: '/user/login/machineId',
                url: '/login/machineId',
                method: 'post',
                data:data,
                headers:{'machineToken':token,'userid':userId}
            }).then(function (res) {
                _this.loading=false;
                if(res.data.code=='200'){
                    var token=res.data.data.token;
                    sessionStorage.setItem('token',token);
                    sessionStorage.setItem('logined','1');
                    _this.$message.success("登录成功！");
                    _this.rightType='4';
                }else{
                    _this.$message.error(res.data.msg);
                }
            }).catch(function (err) {
                _this.loading=false;
            })
        },
        //退出登录
        logOutClick:function () {
            var _this=this;
            this.$confirm('是否退出登录?', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(() => {
                this.loginOut();
             }).catch(() => {

            });
        },
        loginOut:function () {
            var data={
            };
            var _this=this;
            this.$http({
                // url: '/userCenter/userQuit',
                url: '/userCenter/userQuit',
                method: 'post',
                data:data,
            }).then(function (res) {
                if(res.data.code=='200'){
                   _this.changeLoginType();
                }
            }).catch(function (err) {
            })
        },
        jumpProblems:function () {
            window.location.hash="#nomalProblemsBXE";
        },
        moreBtnClick:function () {
            if(this.agreementAgree){
                this.currentIndex='3';
                sessionStorage.setItem('currentIndex','3');
                sessionStorage.setItem('productCode','');
                sessionStorage.setItem('problemTitle','');
                this.$router.push('/problemsList');
            }

        },
        //问题详情
        problemsDetail:function (index) {
            if(this.agreementAgree){
                this.currentIndex='3';
                sessionStorage.setItem('currentIndex','3');
                var item=this.problemInfo[index];
                sessionStorage.setItem('problemTitle',item.problem);
                sessionStorage.setItem('productCode',item.productCode);
                this.$router.push('/problemsList');
            }
        },
        //登录设备更换 获取验证码
        getCodeClick:function(){
          this.timeCountdown();
        },
        timeCountdown:function(){
           var _this=this;
           var data={
               mobile:this.phoneRealNumber,
           }
            this.$http({
                url: '/phone/getPhonecode',
                method: 'post',
                data:data,
            }).then(function (res) {
                // console.log(res);
                if(res.data.code=='200'){
                    if(_this.waitTime==0){
                        _this.codeBtnText='获取验证码';
                        _this.waitTime=60;
                    }else{
                        var timeClock=setInterval(function (args) {
                            _this.waitTime--;
                            if(_this.waitTime==0){
                                _this.codeBtnText='获取验证码';
                                _this.waitTime=60;
                                clearInterval(timeClock);
                            }else{
                                _this.codeBtnText=_this.waitTime+'秒后重新获取';
                            }
                        },1*1000)
                    }
                }else{
                    _this.$message.error(res.data.msg);
                }
            }).catch(function (err) {

            })
        },
        //判断用户有没有同意最新版本的用户协议
        checkNewAgreement:function (loginData){
            var _this=this;
            // var userId=sessionStorage.getItem('userId');
            var userID=loginData.id;
            var data={
                userID: userID,
            }
            var token=loginData.token;

            this.$http({
                url: '/login/userAgreementPromptBox',
                method: 'post',
                data:data,
                headers:{'Authorization':token}
            }).then(function (res) {

                if(res.data.code=='200'){
                    var tempData=res.data.data;
                    if(tempData.isEject=='1'){
                        _this.agreementVisible=true;
                        _this.userAgreementVesion=tempData.userAgreementVesion;
                        _this.privacyAgreementVesion=tempData.privacyAgreementVesion;
                    }else{
                        _this.agreementVisible=false;
                        _this.userAgreementVesion='';
                        _this.privacyAgreementVesion='';
                        //是否更换设备标识
                        if(loginData.machineFlag=='1'){
                            sessionStorage.setItem('userId',loginData.id);
                            var phoneTempNumber=loginData.mobile;
                            var phoneRealNumber=loginData.mobile;
                            _this.phoneRealNumber=phoneRealNumber;
                            var preNumber='';
                            if(phoneTempNumber.length>3){
                                preNumber=phoneTempNumber.substring(0,3);
                            }
                            var endNumber='';
                            if(phoneTempNumber.length>4){
                                endNumber=phoneTempNumber.substring(phoneTempNumber.length-4,phoneTempNumber.length);
                            }
                            _this.phoneNumber=preNumber+'****'+endNumber;
                            //跳转更换设备
                            _this.rightType='3';
                            _this.token=loginData.token;
                            // sessionStorage.setItem('token',token);
                        }else{
                            var token=loginData.token;
                            sessionStorage.setItem('token',token);
                            sessionStorage.setItem('logined','1');
                            sessionStorage.setItem('userId',loginData.id);
                            _this.$message.success("登录成功！");
                            _this.rightType='4';
                        }
                    }
                }else{
                    if(res.data.msg&&res.data.msg.length>0){
                        _this.$message.error(res.data.msg);
                    }
                }
            }).catch(function (err) {
            })
        },
        //登录不同意最新的隐私政策和用户协议
        agreementDisagreeClick:function (){
            this.agreementVisible=false;
            this.agreementAgree=false;
        },
        //登录同意最新的隐私政策和用户协议
        agreementAgreeClick:function (){
            var _this=this;
            var data={
                userID:_this.tempLoginData.id,
                userAgreementVesion:_this.userAgreementVesion,
                privacyAgreementVesion:_this.privacyAgreementVesion,
            }
            this.$http({
                url: '/login/acceptUserAgreement',
                method: 'post',
                data:data,
            }).then(function (res) {
                // console.log(res);
                if(res.data.code=='200'){
                    _this.agreementVisible=false;
                    _this.agreementAgree=true;
                    if(_this.tempLoginData.machineFlag=='1'){
                        sessionStorage.setItem('userId',_this.tempLoginData.id);
                        var phoneTempNumber=_this.tempLoginData.mobile;
                        var phoneRealNumber=_this.tempLoginData.mobile;
                        _this.phoneRealNumber=phoneRealNumber;
                        var preNumber='';
                        if(phoneTempNumber.length>3){
                            preNumber=phoneTempNumber.substring(0,3);
                        }
                        var endNumber='';
                        if(phoneTempNumber.length>4){
                            endNumber=phoneTempNumber.substring(phoneTempNumber.length-4,phoneTempNumber.length);
                        }
                        _this.phoneNumber=preNumber+'****'+endNumber;
                        _this.rightType='3';
                        _this.token=_this.tempLoginData.token;
                        // sessionStorage.setItem('token',token);
                    }else{
                        var token=_this.tempLoginData.token;
                        sessionStorage.setItem('token',token);
                        sessionStorage.setItem('logined','1');
                        sessionStorage.setItem('userId',_this.tempLoginData.id);
                        _this.$message.success("登录成功！");
                        _this.rightType='4';
                    }
                }else{
                    if(res.data.msg&&res.data.msg.length>0){
                        _this.$message.error(res.data.msg);
                    }
                }
            }).catch(function (err) {
            })
        },
        //隐私政策页面打开
        yinSiClick:function (){
            var webSite=this.baseImgUrl+'/webpage/pages/app/app/protocol.html';
            window.open(webSite);
        },
        //用户协议页面打开
        xieyiClick:function (){
            var about=this.baseImgUrl+'/webpage/pages/app/app/about.html';
            window.open(about);
        },
        getAPPStoreImg:function (){
            var _this=this;
            var data={
            }
            this.$http({
                url: '/image/downImg',
                method: 'post',
                data:data,
                headers:{'Authorization':this.token}
            }).then(function (res) {
                if(res.data.code=='200'){
                    _this.imgANUrl=res.data.data.androidBase64;
                    _this.imgIOSUrl=res.data.data.iosBase64
                }else{
                    _this.$message.error(res.data.msg);
                }
            }).catch(function (err) {

            })
        },
    }
}


